import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    observation: '',
    satisfaction: '',
    loadingFeedback: false,
    logoProviderFeedback: ''
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/hotsite/feedback/index.js